<template>
    <div class="contact-us">
        <div class="contact-us-heading">
            <h3>{{ $t("adminMenu.contactUs") }}</h3>
            <div v-if="!loading">
                <router-link class="primary-btn extra-small mobile" :to="{ path: '/app' }">Back</router-link>
            </div>
        </div>
        <div v-show="!loading" class="main-container section-wrap">
            <div class="contact-us-socials-textarea section-wrap">
                <div class="contact-us-container">
                    <div class="contact-us-socials">
                        <div>
                            <span> {{ $t("contactUs.getEmails") }}: </span>
                            <a class="main-text-link" :href="`mailto:${generalOptions.email}`">{{
                                generalOptions.email
                            }}</a>
                        </div>
                        <div>
                            <span>Phone: +1 619-888-3886 </span>
                        </div>
                        <div>
                            <span>{{ $t("marketing.instagram") }}: </span><a class="main-text-link"
                                :href="`https://www.instagram.com/${generalOptions.instagram}`" target="_blank">@{{
                                    generalOptions.instagram }}</a>
                        </div>
                        <div>
                            <span>
                                {{ $t("contactUs.within24") }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="contact-us-textarea">
                    <form>
                        <div class="form-textarea">
                            <textarea v-model="message" class="text-field" id="message" rows="3"
                                placeholder="Message Content"></textarea>
                        </div>
                        <button v-on:click="sendMessage" type="button"
                            class="primary-btn extra-small mobile">Send</button>
                    </form>
                </div>
            </div>
            <client-notifications ref="clientNotifications" @loading="loading = $event"></client-notifications>
        </div>
        <MainLoader v-if="loading" class="section-wrap" />
    </div>
</template>

<script>
import "bootstrap";
import api from "../../services/apiEndpoints.js";
import auth from "../../services/auth.js";
import store from "../../services/vuex.js";
import eventBus from "../../services/eventBus.js";
import messages from "../../services/messages.js";

import ClientNotifications from "./ClientNotifications.vue";
import MainLoader from "./general-components/MainLoader.vue";

export default {
    name: "ContactUs",
    data: function () {
        return {
            user: null,
            message: "",
            supportMessages: [],
            loading: false,
        };
    },
    mounted: function () {
        this.user = auth.state.user;

        eventBus.on("user_profile_loaded", function () {
            self.user = auth.state.user;
        });
    },
    beforeUnmount() {
        eventBus.off("admin_details_loaded");
        eventBus.off("user_profile_loaded");
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
        localNotificationCount: {
            get: function () {
                return this.$store.state.localNotificationCount;
            },
            set: function (value) {
                this.$store.commit("setLocalNotificationCount", value);
            },
        },
    },
    methods: {
        sendMessage: function () {
            let data = {
                message: this.message,
            };
            this.$http.post(api.actions.send_message_to_support, data).then(
                function (response) {
                    if (response.data.error) {
                        return;
                    }
                    messages.successMessage(messages.GLOBAL_MESSAGES.MESSAGE_SENT_TO_SUPPORT);
                    this.message = "";

                    // refresh child component
                    this.$refs.clientNotifications.getUserSupportMessages();
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
    },

    components: {
        ClientNotifications,
        MainLoader,
    },
};
</script>
<style lang="scss">
.support-message-history {
    width: 100%;
}
</style>
